import _ from 'lodash'

import {
    INSPECTIONS_TABLE_CHANGE,
    INSPECTIONS_TABLE_CHANGE_REQUEST,
    INSPECTIONS_TABLE_DATA_RECEIVED,
    INSPECTIONS_TABLE_LOADING_TRUE,
    INSPECTIONS_TABLE_LOADING_FALSE,
} from './constants'

import config from '../../../../../../../../../config'

export function inspectionsTableChange(module, blockKey, id, level, customData, queryParams) {
    return {
        type: INSPECTIONS_TABLE_CHANGE,
        data: {
            module,
            blockKey,
            id,
            level,
            customData,
            queryParams,
        },
    }
}

export function inspectionsTableChangeRequest(module, blockKey, id, level, lang, token, queryParams) {
    return {
        type: INSPECTIONS_TABLE_CHANGE_REQUEST(id),
        payload: {
            uri: _.get(config, `api.report.${blockKey}.block[1].uri`),
            qs: {
                ...queryParams,
                entId: id,
                lang,
                token,
                level,
            },
            uriParams: {
                entId: id,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function inspectionsTableDataReceived(module, id, blockKey, customData) {
    return {
        type: INSPECTIONS_TABLE_DATA_RECEIVED,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function inspectionsTableLoadingTrue(module, id, blockKey, customData) {
    return {
        type: INSPECTIONS_TABLE_LOADING_TRUE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function inspectionsTableLoadingFalse(module, id, blockKey, customData) {
    return {
        type: INSPECTIONS_TABLE_LOADING_FALSE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
